export default "__VITE_ASSET__C0lmD4k1__"